/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Card, Grid } from '@mui/material';
import { shadowColor } from 'theme/color';
import {
  fontsize16,
  fontsize24,
  poppins400,
  poppins500,
} from 'theme/common.style';

function PropertyDescription(props) {
  return (
    <Card
      variant="outlined"
      style={{
        borderRadius: '8px',
        boxShadow: `0px 1px 8px ${shadowColor}`,
        padding: '30px 20px',
        marginTop: '14px',
      }}
    >
      <Grid>
        <Grid sx={{ ...poppins500, ...fontsize24 }}>Description</Grid>
        <Grid sx={{ ...poppins400, ...fontsize16 }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Purus sodales
          egestas dolor amet aliquam. Blandit non nibh congue bibendum amet,
          leo. Eu accumsan, sit vitae, vel dictum auctor tortor sit. Eros amet,
          eu mi lorem lacinia euismod. Eu pulvinar arcu, sed euismod elit nisl,
          etiam ultrices. Id ut lacus, vulputate ut quisque bibendum. Id sed sed
          et tristique leo in. Mattis molestie velit lectus lobortis cursus
          enim. Ultricies lectus elementum rhoncus vivamus vel. Purus egestas
          egestas at facilisis nullam non gravida. Commodo ut morbi sed
          adipiscing sollicitudin consequat, in. Quam viverra pellentesque lorem
          suspendisse pulvinar lectus non odio donec. Ut integer vitae feugiat
          justo. Facilisis eu, donec molestie gravida consequat. Eu in eu purus
          sit dolor faucibus enim sed. Lectus eros, luctus in diam tortor enim
          in ipsum vitae. Diam in ut proin adipiscing integer praesent ut semper
          adipiscing. Diam aliquet scelerisque mauris in aliquet eu sit
          vulputate sapien. Velit, convallis mi praesent nulla leo urna,
          vulputate diam. At a vivamus mauris consectetur mattis non interdum
          tristique. Viverra nulla eget pharetra, sagittis, ullamcorper. Lorem
          nunc tellus nunc, eget ullamcorper neque tellus. Mattis cras ac
          gravida nec arcu. Id donec tincidunt enim orci.
        </Grid>
      </Grid>
    </Card>
  );
}

PropertyDescription.propTypes = {};

export default PropertyDescription;
